import { useId } from 'react';
import { NavigationListItem } from '../../Atoms';
import { NavigationListProps } from './NavigationList.types';

export default function NavigationList({ name, items, disableTooltip }: NavigationListProps) {
    const headingId = useId();

    return (
        <div className="w-full flex flex-col justify-start items-start space-y-2">
            <span
                id={headingId}
                className="text-lg font-bold text-(--color-sidebar-group-text) lg:text-sm"
            >
                {name}
            </span>
            <ul
                aria-labelledby={headingId}
                className="w-full flex flex-col justify-start items-start space-y-1"
            >
                {items.map((item) => (
                    <li key={item.label} className="w-full">
                        <NavigationListItem {...item} disableTooltip={disableTooltip} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
